import React from "react";
import { Dropdown, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";

export const ExpMenu: React.FC<{ onChange: (value: string) => void }> = ({
  onChange,
}) => {
  const handleChange = (value: string) => {
    onChange(value);
  };
  const menu = (
    <Menu>
      <Menu.Item key="CASE" onClick={() => handleChange("CASE")}>
        CASE
      </Menu.Item>
      <Menu.Item
        key="Literal Value"
        onClick={() => handleChange("literalValue")}
      >
        Literal Value
      </Menu.Item>
      <Menu.Item
        key="Data Field Path"
        onClick={() => handleChange("dataFieldPath")}
      >
        Data Field Path
      </Menu.Item>
      <Menu.Item key="Functions" onClick={() => handleChange("functions")}>
        Functions
      </Menu.Item>
      <Menu.Item
        key="unary arithmetic"
        onClick={() => handleChange("UnaryArithmetic")}
      >
        Unary Arithmetic
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <MoreOutlined />
    </Dropdown>
  );
}; 